const part = [
    {
        path: 'aboutcontacing-management-list',
        name: 'aboutcontacing-management-list',
        meta: {
            icon: 'md-people',
            title: '关于我们联系我们',
            notCache: true,
            access: ['S'],
            items: [
            ]
        },
        component: () => import('@/view/system-management/aboutcontacting-managment/about-contacting-us')
    }
];

export default part;
